
import React from "react";
import { Briefcase, CheckCircle2, Circle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";

const CareerQuests = () => {
  return (
    <div>
      <div>
        <h4 className="text-sm font-medium mb-2">Coming Next Week</h4>
        <div className="bg-background rounded-lg border p-3 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Briefcase className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium text-sm">Build a Mini Business</p>
              <p className="text-xs text-muted-foreground">Entrepreneurship Track</p>
            </div>
          </div>
          <Badge variant="outline">Locked</Badge>
        </div>
      </div>
      
      <div className="mt-4">
        <div className="bg-background rounded-lg border p-3 flex justify-between items-center">
          <div className="flex items-center gap-2">
            <Briefcase className="h-4 w-4 text-muted-foreground" />
            <div>
              <p className="font-medium text-sm">Create Your First Webpage</p>
              <p className="text-xs text-muted-foreground">Tech Track</p>
            </div>
          </div>
          <Badge variant="outline">Coming Soon</Badge>
        </div>
      </div>
    </div>
  );
};

export default CareerQuests;
